/* @flow */
import cx from 'classnames';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import React from 'react';

import './styles/JoinAvatarPanel.scss';

const JoinGroupAvatarPanel = React.createClass({
  propTypes: {
    group: React.PropTypes.instanceOf(Group).isRequired,
  },

  render() {
    const { group } = this.props;

    return (
      <div className={cx('JoinAvatarPanel', this.props.className)}>
        <div className="JoinAvatarPanel-Image">
          <GroupAvatar group={this.props.group} />
        </div>

        <div className="JoinAvatarPanel-Header">
          <h4>
            <p>{this.props.group.getPossessiveSignature()}</p>
            <strong>
              <GroupName group={group} />
            </strong>
          </h4>
        </div>

        <div className="JoinAvatarPanel-Footer">
          <div>
            {this.props.group.getOrganization() && this.props.group.getOrganization().getName()}
          </div>
          <div>
            @{this.props.group.getCode()}
          </div>
        </div>
      </div>
    );
  },
});

export default JoinGroupAvatarPanel;



// WEBPACK FOOTER //
// ./src/join/components/JoinGroupAvatarPanel.jsx